/* CLEARED theme — global.js
   Scroll reveal, parallax, mobile menu, horizontal rails, sliders,
   comparison-table check animation, flow-line draw. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animate = window.clearedSettings && window.clearedSettings.animations && !reduced;

  if (animate) document.body.classList.add('animations-enabled');

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    if (!animate) return;
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- parallax ---------- */
  function initParallax() {
    if (!animate) return;
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    var onScroll = function () {
      els.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        var parent = el.parentElement.getBoundingClientRect();
        var d = (parent.top + parent.height / 2 - window.innerHeight / 2) * f;
        var rot = el.style.transform.match(/rotate\([^)]*\)/);
        el.style.transform = 'translateY(' + d.toFixed(1) + 'px) ' + (rot ? rot[0] : '');
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    var overlay = document.querySelector('[data-menu-overlay]');
    function open() {
      menu.classList.add('is-open');
      if (overlay) overlay.classList.add('is-active');
    }
    function close() {
      menu.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-active');
    }
    document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    document.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
  }

  /* ---------- horizontal scroll rails (ingredients etc.) ---------- */
  function initRails() {
    document.querySelectorAll('[data-rail]').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-rail-track]');
      if (!rail) return;
      var step = parseInt(wrap.getAttribute('data-rail-step'), 10) || 322;
      wrap.querySelectorAll('[data-rail-prev]').forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: -step, behavior: 'smooth' }); });
      });
      wrap.querySelectorAll('[data-rail-next]').forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: step, behavior: 'smooth' }); });
      });
    });
  }

  /* ---------- card sliders (reviews) ---------- */
  function initSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-slider-track]');
      if (!track) return;
      var cards = track.children;
      if (!cards.length) return;
      var visible = parseInt(wrap.getAttribute('data-slider-visible'), 10) || 3;
      var slide = 0;
      var prev = wrap.querySelector('[data-slider-prev]');
      var next = wrap.querySelector('[data-slider-next]');

      function maxSlide() {
        var perView = window.innerWidth < 750 ? 1 : visible;
        return Math.max(0, cards.length - perView);
      }
      function update() {
        var card = cards[0];
        var gap = parseFloat(getComputedStyle(track).gap) || 24;
        var w = card.getBoundingClientRect().width + gap;
        track.style.transform = 'translateX(' + (-slide * w) + 'px)';
        if (prev) prev.classList.toggle('is-disabled', slide === 0);
        if (next) next.classList.toggle('is-disabled', slide >= maxSlide());
      }
      if (prev) prev.addEventListener('click', function () { slide = Math.max(0, slide - 1); update(); });
      if (next) next.addEventListener('click', function () { slide = Math.min(maxSlide(), slide + 1); update(); });
      window.addEventListener('resize', function () { slide = Math.min(slide, maxSlide()); update(); });
      update();
    });
  }

  /* ---------- comparison table check-in animation ---------- */
  function initComparison() {
    document.querySelectorAll('[data-comparison]').forEach(function (section) {
      var checks = section.querySelectorAll('[data-check]');
      if (!animate) {
        checks.forEach(function (c) { c.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            checks.forEach(function (c) { c.classList.add('is-in'); });
            io.disconnect();
          }
        });
      }, { threshold: 0.3 });
      io.observe(section);
    });
  }

  /* ---------- SVG flow line draw (how it's made / results flow) ---------- */
  function initFlowLines() {
    document.querySelectorAll('[data-flow]').forEach(function (section) {
      var path = section.querySelector('[data-flow-path]');
      var dot = section.querySelector('[data-flow-dot]');
      function drawn() {
        if (path) path.style.strokeDashoffset = '0';
        if (dot) dot.style.opacity = '1';
      }
      if (!animate) { drawn(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { drawn(); io.disconnect(); }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    });
  }

  function initAll() {
    initReveal();
    initParallax();
    initMobileMenu();
    initRails();
    initSliders();
    initComparison();
    initFlowLines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* re-init inside sections re-rendered by the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initRails();
    initSliders();
    initComparison();
    initFlowLines();
  });

  window.clearedGlobal = { initReveal: initReveal };
})();
